document.addEventListener(
    "DOMContentLoaded",
    function () {
        import("./core/details").then((module) => {
            module.init();
        });
    }
);
